import HeroSection from "./components/HeroSection";
import BannerSection from "./components/BannerSection";
import ProductsSection from "./components/ProductsSection";
import NewsletterSection from "./components/NewsletterSection";
import TrustSection from "./components/TrustSection";
import StorySection from "./components/StorySection";
import InstagramSection from "./components/InstagramSection";
import ShoppableVideosSection from "./components/ShoppableVideosSection";
import CategoryBanner from "./components/CategoryBanner";
import VideoBanner from "./components/VideoBanner";
import { useHomeData } from "@/hooks/useApi";

export default function HomePage() {
  const { data } = useHomeData();

  return (
    <main>
      <HeroSection />
      {/* <TrustSection items={data?.trustItems} />
      <BannerSection /> */}
      <ProductsSection
        featured={data?.featuredProducts}
        latest={data?.latestProducts}
      />
      <CategoryBanner categoryName="بطاقات الهدايا" />
      <ShoppableVideosSection />
      <CategoryBanner categoryName="العناية بالجسم" />
      <VideoBanner />
      <InstagramSection />
      <NewsletterSection />
    </main>
  );
}
